export function playerFavoritesReady(store) {
    return new Promise((resolve, reject) => {
      const startTime = Date.now();
      const maxWaitTime = 10000; // 10 seconds
      const checkInterval = 300; // 0.3 seconds
  
      const checkLoaded = () => {
        const favoritesReady = store.state.myFavoritesRawLoaded;
        const hasData = Array.isArray(store.state.myFavoritesRaw);
  
        if (favoritesReady || (hasData && store.state.myFavoritesRaw.length === 0)) {
          resolve();
        } else if (Date.now() - startTime > maxWaitTime) {
          reject(new Error('Timeout waiting for myFavoritesRawLoaded to be true'));
        } else {
          setTimeout(checkLoaded, checkInterval);
        }
      };
  
      checkLoaded();
    });
  }
  